import { INITIAL_Z_INDEX } from '../VDialog';
import VDialog from '../VDialog/VDialog';
import { joinCn } from '../util';
import { DRAWER_POSITION } from './constant';
import twStyle from './style';
import type { VDrawerProps } from './type';

const VDrawer = (props: VDrawerProps) => {
  const {
    children,
    position = DRAWER_POSITION.LEFT,
    initialZIndex,
    dialogMainClass,
    dialogContainerClass,
    ...VDialogProps
  } = props;

  const style = twStyle({ ...props });

  return (
    <VDialog
      transition={
        position === DRAWER_POSITION.LEFT
          ? 'slide-x'
          : position === DRAWER_POSITION.RIGHT
            ? 'slide-reverse-x'
            : position === DRAWER_POSITION.TOP
              ? 'slide-y'
              : position === DRAWER_POSITION.BOTTOM
                ? 'slide-reverse-y'
                : undefined
      }
      {...VDialogProps}
      initialZIndex={initialZIndex ?? INITIAL_Z_INDEX.DRAWER}
      position={position}
      dialogContainerClass={joinCn('!p-0', dialogContainerClass)}
      dialogMainClass={joinCn('rounded-none', style.main, dialogMainClass)}
    >
      <div
        className={joinCn({
          'h-screen':
            position === DRAWER_POSITION.LEFT ||
            position === DRAWER_POSITION.RIGHT,
          'w-screen':
            position === DRAWER_POSITION.TOP ||
            position === DRAWER_POSITION.BOTTOM,
        })}
      >
        {children}
      </div>
    </VDialog>
  );
};

export default VDrawer;
